import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CustomerCare from "@/assets/icons/chatIcon.png";
import Whatsapp from "@/assets/icons/whatsapp.png";
import { userWebsitePaths } from "@/constants/userWebsitePaths";
import { useSafeAreaInsets } from '@/hooks/useSafeAreaInsets';
import { notifyParentToOpenChat } from '@/utils/mainSiteNavigateFromIframe';

export default function FloatingSupportButtons() {
  const location = useLocation();
  const [bottomClass, setBottomClass] = useState("bottom-[10px]");
  const { bottomSafeComponent } = useSafeAreaInsets();

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const path = location.pathname;

      if (width < 1000 && path === '/watch') {
        setBottomClass("bottom-[95px]");
      } else if (
        width < 1200 &&
        (path === '/' || path.startsWith('/resources/') || path.startsWith('/subscriptionGroup/'))
      ) {
        setBottomClass("bottom-[90px]");
      } else {
        setBottomClass("bottom-[10px]");
      }
    };

    handleResize(); // On mount
    window.addEventListener("resize", handleResize); // On resize

    return () => window.removeEventListener("resize", handleResize);
  }, [location.pathname]);

  return (
    <div className={`fixed ${bottomClass} right-4 z-50 flex flex-col gap-2`}>
      {location.pathname !== '/watch' ? <a href={userWebsitePaths.whatsApp} target="_blank" rel="noopener noreferrer">
        <img
          src={Whatsapp}
            alt="WhatsApp"
            width={50}
            height={50}
            className="rounded-full w-[50px] h-[50px] md:w-[60px] md:h-[60px]"
          />
        </a> : null}
      <button
        type="button"
        onClick={notifyParentToOpenChat}
        className="p-0 border-0 bg-transparent cursor-pointer"
      >
        <img
          src={CustomerCare}
          alt="Customer Care"
          width={50}
          height={50}
          className="rounded-full w-[50px] h-[50px] md:w-[60px] md:h-[60px]"
        />
      </button>
      {bottomSafeComponent}
    </div>
  );
}
